import {CHANGE_MAIN} from '../actions/constants'

export default function main(state = {}, action)
{
    switch (action.type){
        case CHANGE_MAIN:
            return Object.assign(
                {}, 
                state,
                action.main
            )

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/main.js